import script from "./AddUsersToGroupModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddUsersToGroupModal.vue?vue&type=script&setup=true&lang=js"

import "./AddUsersToGroupModal.vue?vue&type=style&index=0&id=436008fc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-436008fc"]])

export default __exports__